import { ContactForm } from '~modules/jsm-contact/components/ContactForm';
import { createPortalBaseUrl } from '~modules/jsm-contact/shared/helpers';
import { type BlockFormData } from '~modules/jsm-contact/shared/types';
import useMediaLibrarySettings from '~modules/media-library/context/useMediaLibrarySettings';

type JsmContactFormProps = {
  onClose?: () => void;
  assetId: string;
};

export function JsmContactForm({ assetId }: JsmContactFormProps) {
  const { additionalSettings } = useMediaLibrarySettings();
  if (additionalSettings.jsm_contact_form === undefined) return 'Missing Settings';

  const formSettings = additionalSettings.jsm_contact_form;

  let defaultFormData: BlockFormData = {};
  if (formSettings.asset_id_field_id !== undefined) {
    defaultFormData[formSettings.asset_id_field_id] = assetId;
  }

  // Render form
  return (
    <>
      <div className="raise-request-assets-form container py-1 px-3">
        <ContactForm
          dataKey={formSettings.dataKey}
          portalBaseUrl={createPortalBaseUrl(formSettings.portalBaseUrl)}
          requestTypeId={formSettings.requestTypeId.toString()}
          defaultFormData={defaultFormData}
        />
      </div>
    </>
  );
}
